export function boolFilter(input: boolean): string {

    if(input === null){
        return null;
    }

    const i18n: any = this.context.i18n.global;

    return input ? i18n.t('core.formatting.boolean.true') : i18n.t('core.formatting.boolean.false');
}